module.exports = __webpack_public_path__ + "img/map_19.37723ee0.png";